import { useTranslation } from 'react-i18next';

export default function Sectors() {
  const { t } = useTranslation();

  const sectors = [
    {
      titleKey: 'sectors.manufacturera.titulo',
      descriptionKey: 'sectors.manufacturera.descripcion',
      icon: 'ri-tools-line',
      image: '/sectors/manufacturera.jpg'
    },
    {
      titleKey: 'sectors.agroalimentaria.titulo',
      descriptionKey: 'sectors.agroalimentaria.descripcion',
      icon: 'ri-plant-line',
      image: '/sectors/agroalimentaria.webp'
    },
    {
      titleKey: 'sectors.quimica.titulo',
      descriptionKey: 'sectors.quimica.descripcion',
      icon: 'ri-flask-line',
      image: 'https://images.unsplash.com/photo-1532187863486-abf9dbad1b69?w=400&h=300&fit=crop'
    },
    {
      titleKey: 'sectors.bebidas.titulo',
      descriptionKey: 'sectors.bebidas.descripcion',
      icon: 'ri-goblet-line',
      image: '/sectors/bebidas.webp'
    },
    {
      titleKey: 'sectors.caucho.titulo',
      descriptionKey: 'sectors.caucho.descripcion',
      icon: 'ri-recycle-line',
      image: '/sectors/caucho.jpg'
    },
    {
      titleKey: 'sectors.textil.titulo',
      descriptionKey: 'sectors.textil.descripcion',
      icon: 'ri-shirt-line',
      image: '/sectors/textil.jpg'
    }
  ];

  return (
    <section id="sectores" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            {t('sectors.titulo')}
          </h2>
          <p className="text-xl text-gray-600">
            {t('sectors.subtitulo')}
          </p>
        </div>

        {/* Sectores */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {sectors.map((sector, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300"
            >
              <div className="h-48 bg-cover bg-center" style={{ backgroundImage: `url(${sector.image})` }}></div>
              <div className="p-6">
                <div className="flex items-center mb-3">
                  <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mr-4">
                    <i className={`${sector.icon} text-xl text-teal-600`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900">
                    {t(sector.titleKey)}
                  </h3>
                </div>
                <p className="text-gray-600 leading-relaxed">
                  {t(sector.descriptionKey)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
